export default __webpack_public_path__ + "static/media/people_type_male.6d9c0ff6.svg";